import { BranchResponse } from '@/app/models/branch';
import { useBranchsAllQuery } from '@/app/services/branchApi';
import { useListSearchByBranchQuery } from '@/app/services/overheadApi';
import OverheadTable from '@/components/Overhead/OverheadTable';
import { useBranch } from '@/context/BranchsContext';
import { usePeriod } from '@/context/PeriodContext';
import { Box, FormControl, MenuItem, Select, Typography, useTheme } from '@mui/material';
import { t } from 'i18next';
import { useEffect } from 'react';

function Overhead() {
  const { selectedPeriod } = usePeriod();

  const { selectedBranch, setSelectedBranch } = useBranch();
  const { data: branchs } = useBranchsAllQuery();
  useEffect(() => {
    if (selectedBranch && branchs?.content && !branchs.content.find((b) => b.code === selectedBranch)) {
      setSelectedBranch('');
    }
  }, [branchs, selectedBranch, setSelectedBranch]);
  const theme = useTheme();
  const { data: listSearchByBranch } = useListSearchByBranchQuery(
    {
      date: selectedPeriod?.date as string,
      branch: selectedBranch as string,
    },
    { skip: !selectedPeriod },
  );

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        mr: 2,
      }}
    >
      <Box
        sx={{
          mt: 2,
        }}
      />
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Box sx={{ minWidth: theme.spacing(31) }}>
          <Typography component="p" variant="fieldHeader">
            {t('common:branch')}
          </Typography>

          <FormControl sx={{ width: theme.spacing(30) }}>
            <Select
              displayEmpty
              value={selectedBranch}
              onChange={(e) => setSelectedBranch(e.target.value)}
              sx={{
                height: 32,
                fontSize: 14,
              }}
            >
              <MenuItem value="" sx={{ color: '#9e9e9e' }}>
                {t('common:select.branch')}
              </MenuItem>
              {branchs?.content.map((item: BranchResponse) => (
                <MenuItem key={item.code} value={item.code} sx={{ fontSize: 13 }}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
      <OverheadTable rows={listSearchByBranch || []} />
    </Box>
  );
}

export default Overhead;
